import {
  getDraftOptions,
  listDraftGenerationsOptions,
} from "@/api/generated/@tanstack/react-query.gen";
import { useHasPermissions } from "@/components/misc/protected";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Navigate, useParams } from "@tanstack/react-router";

function RedirectToStage() {
  const { id } = useParams({ from: "/draft-experiments/$id/" });

  const { data: experiment } = useQuery({
    ...getDraftOptions({ path: { experiment_id: id } }),
  });

  const { data: generationsData } = useQuery({
    ...listDraftGenerationsOptions({ path: { experiment_id: id } }),
    enabled: !!experiment,
  });

  const hasSetupRead = useHasPermissions({ requires: "org:draft_experiments:setup_read" });
  const hasGenerateRead = useHasPermissions({ requires: "org:draft_experiments:generate_read" });
  const hasReviewRead = useHasPermissions({ requires: "org:draft_experiments:review_read" });

  const slots = experiment?.content_slots ?? [];
  const variants = experiment?.variants ?? [];
  const generations = generationsData?.items ?? [];
  const hasSlots = slots.length > 0;
  const hasGenerations = variants.length > 0 && generations.length > 0;

  const naturalTab = hasGenerations ? "review" : hasSlots ? "generation" : "setup";

  const tabAccessible = {
    setup: hasSetupRead,
    generation: hasGenerateRead,
    review: hasReviewRead,
  };

  const tab = tabAccessible[naturalTab]
    ? naturalTab
    : (["setup", "generation", "review"] as const).find((t) => tabAccessible[t]) ?? naturalTab;

  return (
    <Navigate
      to={`/draft-experiments/$id/${tab}`}
      params={{ id }}
      replace
    />
  );
}

export const Route = createFileRoute("/draft-experiments/$id/")({
  component: RedirectToStage,
});
